const vendors = {}

export default vendors